import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';

const ProtectedRoute = ({ isLoggedIn, children }) => {
  // Auth check still in flight (page refresh) — wait instead of redirecting
  if (isLoggedIn === null) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minH="60vh">
        <Spinner size="xl" color="gray.500" />
      </Box>
    );
  }

  if (!isLoggedIn) {
    // Redirect to login if the user is not logged in
    return <Navigate to="/login" replace />;
  }

  return children; // Render children if logged in
};

export default ProtectedRoute;
